import { Component, Input, OnInit } from '@angular/core';

export type InfiniteScrollProfileImage = {
  presigned_url?: string | null;
  media_name?: string | null;
};

export type InfiniteScrollItem = {
  user_id?: string | number | null;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  profileImage?: InfiniteScrollProfileImage | null;
  isParticipated?: boolean;
};

@Component({
  selector: 'app-infinite-scroll-component',
  templateUrl: './infinite-scroll-component.component.html',
  styleUrls: ['./infinite-scroll-component.component.scss'],
})
export class InfiniteScrollComponentComponent implements OnInit {
  @Input() loading!: boolean;
  @Input() hasMoreData!: boolean;
  @Input() items: InfiniteScrollItem[] = [];
  @Input() loadMore?: () => void;

  constructor() {}

  ngOnInit(): void {
    // if (!Array.isArray(this.items) || this.items.length === 0) {

    this.triggerLoadMore();
    // }
  }

  triggerLoadMore(): void {
    if (this.loading) return;
    if (typeof this.loadMore !== 'function') return;
    this.loadMore();
  }

  getFullName(item: InfiniteScrollItem): string {
    const firstName = (item?.first_name ?? '').trim();
    const lastName = (item?.last_name ?? '').trim();
    return `${firstName} ${lastName}`.trim();
  }

  getInitials(item: InfiniteScrollItem): string {
    const firstName = (item?.first_name ?? '').trim();
    const lastName = (item?.last_name ?? '').trim();

    const firstInitial = this.firstAlpha(firstName);
    const lastInitial = this.firstAlpha(lastName);

    const initialsFromName = `${firstInitial}${lastInitial}`.toUpperCase();
    if (initialsFromName.trim().length > 0) return initialsFromName;

    const email = (item?.email ?? '').trim();
    const emailInitial = this.firstAlpha(email).toUpperCase();
    if (emailInitial) return emailInitial;

    return 'U';
  }

  private firstAlpha(value: string): string {
    if (!value) return '';
    const match = value.match(/[A-Za-z0-9]/);
    return match?.[0] ?? '';
  }

  trackById(index: number, item: InfiniteScrollItem) {
    return item?.user_id;
  }

  getParticipateClass(isParticipated: boolean) {
    return {
      'badge-yes': isParticipated,
      'badge-no': !isParticipated,
    };
  }
  getParticipateDotClass(isParticipated: boolean) {
    return {
      'dot-g': isParticipated,
      'dot-r': !isParticipated,
    };
  }
}
